import React, { useState, useEffect, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import { customGetAPI } from "services/utils/CustomAPI";
import { customGetAPIWithToken } from "services/utils/CustomAPI";
import {
  pathAndProducts,
  supportLabel,
  adminRoleName,
} from "./services/constants/index";
import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  useLocation,
} from "react-router-dom";
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/organflow-dashboard.scss?v1.2.1";
import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { getAccessBasedRoute } from "services/utils/accessedBasedRoute";
import {
  setReloadApi,
  setReloadHRMSApi,
  setAllStatus,
  setActiveStatus,
  setLeaveStatus,
  setOnBreakStatus,
} from "services/Redux/leaveManagement";
import {
  setCurrentUser,
  setCurrentLocation,
  setScreenAccess,
  setProductAccess,
  setVisible,
  setCompanyList,
} from "./services/Redux/userToken";
import {
  setCurrentScreen,
  setSubMenuExpand,
  setEditUserDetailsApi,
  setEditUserId,
} from "services/Redux/userManagament";
import { toastContainerStyle } from "./services/constants/index";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import { showToast } from "services/utils/Status";
import sessionHandling from "services/utils/notificationUtils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getRoutesByRole } from "routes";
import "App.css";
import KnowlarityWidget2 from "components/KnowlarityWidget2";
import { Loader } from "components/Loader";
let currentUserDetails = {};
const firebaseConfig = {
  apiKey: "AIzaSyBmyL25iSMeSEwzxwW7z0L2n9cKtG5xhjM",
  authDomain: "organflowprod.firebaseapp.com",
  projectId: "organflowprod",
  storageBucket: "organflowprod.firebasestorage.app",
  messagingSenderId: "1044068366550",
  appId: "1:1044068366550:web:3f5b6fe81e07ac449f3177",
  measurementId: "G-D1SFPGH4W3",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
export { messaging };

export default function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const urlParams = new URLSearchParams(window.location.search);
  const tokenDetails = urlParams.get("token");
  const userEmail = urlParams.get("email");
  const userPhoneNumber = urlParams.get("ph_no");
  let user_token = useSelector((state) => state.tokenReducer.token);
  let [redirect, setRedirect] = useState("");
  let [authenticated, setAuthenticated] = useState(false);
  const [deploying, setDeploying] = useState(false);
  const domainUrl = useSelector((state) => state.tokenReducer.domain);
  const token = useSelector((state) => state.tokenReducer.token);
  // console.log("Redux visible changed:", visible);
  const date = new Date().toISOString().split("T")[0];
  const routes = getRoutesByRole(
    JSON.parse(localStorage.getItem("productAccess"))
      ? JSON.parse(localStorage.getItem("productAccess"))
      : null
  );
  if (tokenDetails) {
  }
  console.log(deploying);

  const updateUserToken = useCallback(
    async (userToken, userId) => {
      try {
        function getCSRFToken() {
          return document.cookie
            .split("; ")
            .find((row) => row.startsWith("csrftoken="))
            ?.split("=")[1];
        }

        const isLocalhost =
          window.location.hostname === "localhost" ||
          window.location.hostname.startsWith("127.");

        let response;

        if (!isLocalhost) {
          await fetch(`${domainUrl}csrf/`, { credentials: "include" });

          response = await fetch(`${domainUrl}fcm_token/`, {
            method: "PUT",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              "X-CSRFToken": getCSRFToken(),
            },
            body: JSON.stringify({ fcm_token: userToken, user_id: userId }),
          });
        } else {
          response = await fetch(`${domainUrl}fcm_token/`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ fcm_token: userToken, user_id: userId }),
          });
        }

        if (!response.ok) {
          throw new Error("Failed to update the token on the server");
        }
      } catch (error) {
        console.log(error.message);
      }
    },
    [domainUrl]
  );

  React.useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data?.deploymentInProgress) {
          localStorage.setItem("deploymentInProgress", "true");
          setDeploying(true);
          localStorage.clear();
          localStorage.setItem("LoginTag", "Email");
          history.push("/auth/login");
          window.location.reload();
        }
      });
    }

    if (localStorage.getItem("deploymentInProgress") === "true") {
      setDeploying(true);
    }
  }, [history]);

  const callYourApiFunction = useCallback(async () => {
    try {
      const response = await fetch(`${domainUrl}checkinfilter/?date=${date}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
      });
      if (response.status === 409) {
        sessionHandling();
      }
      dispatch(setReloadApi(true));
      dispatch(setAllStatus(true));
      dispatch(setReloadHRMSApi(true));
      dispatch(setActiveStatus(true));
      dispatch(setLeaveStatus(true));
      dispatch(setOnBreakStatus(true));
      await response.json();
    } catch (error) {
      showToast("error", "Error fetching data:", error);
    }
  }, [date, dispatch, domainUrl, token]);

  const getUserModuleAccess = useCallback(
    async (userId, companyId, module) => {
      const res = await customGetAPI(
        `${domainUrl}product/access/provisioning/?user_id=${userId}&company_id=${companyId}&module=${module}`
      );
      if (res.ok) {
        let updatedData = res?.responseDetails;
        dispatch(setScreenAccess(updatedData));
        localStorage.setItem("screenAccess", JSON.stringify(updatedData));
      }
    },
    [dispatch, domainUrl]
  );

  const updateCompanyDetails = useCallback(
    async (token, userId, domainUrl) => {
      const companyAccess = await customGetAPIWithToken(
        `${domainUrl}user-group/user/company/?user_id=${userId}`,
        token
      );
      if (companyAccess.ok) {
        dispatch(setCompanyList(JSON.stringify(companyAccess.responseDetails)));
        localStorage.setItem(
          "companyAccess",
          JSON.stringify(companyAccess.responseDetails)
        );
        let companyId =
          companyAccess.responseDetails?.length !== 0
            ? companyAccess?.responseDetails[0]?.company_id
            : 99999;
        localStorage.setItem("topbarCompanyId", companyId);
        localStorage.setItem(
          "topbarCompanyName",
          companyAccess.responseDetails?.length !== 0
            ? companyAccess?.responseDetails[0]?.company_name
            : "All Companies"
        );
        const response = await customGetAPIWithToken(
          `${domainUrl}login/available/products/?user_id=${userId}&company_id=${companyId}`,
          token
        );
        if (response.ok) {
          dispatch(setProductAccess(response.responseDetails));
          localStorage.setItem(
            "productAccess",
            JSON.stringify(response.responseDetails)
          );
        }
      }
    },
    [dispatch]
  );

  const getCurrentUserAccessibleCompany = useCallback(
    async (token, userId, domainUrl) => {
      const companyAccess = await customGetAPIWithToken(
        `${domainUrl}user-group/user/company/?user_id=${userId}`,
        token
      );
      if (companyAccess.ok) {
        dispatch(setCompanyList(JSON.stringify(companyAccess.responseDetails)));
        localStorage.setItem(
          "companyAccess",
          JSON.stringify(companyAccess.responseDetails)
        );
        let companyId =
          companyAccess?.responseDetails?.length !== 0
            ? companyAccess?.responseDetails[0]?.company_id
            : 99999;
        localStorage.setItem("topbarCompanyId", companyId);
        localStorage.setItem(
          "topbarCompanyName",
          companyAccess.responseDetails?.length !== 0
            ? companyAccess?.responseDetails[0]?.company_name
            : "All Companies"
        );
        const response = await customGetAPIWithToken(
          `${domainUrl}login/available/products/?user_id=${userId}&company_id=${companyId}`,
          token
        );
        if (response.ok) {
          dispatch(setProductAccess(response.responseDetails));
          localStorage.setItem(
            "productAccess",
            JSON.stringify(response.responseDetails)
          );
          window.location.reload();
        } else {
          window.location.reload();
        }
      }
    },
    [dispatch]
  );

  const getRouteNames = useCallback(
    (user_id, redirect_path) => {
      let count = 0;
      if (redirect_path !== "/") {
        routes.forEach((route) => {
          if (route.collapse) {
            count = count + 1;
            route.collapse.forEach((collapsedRoute) => {
              if (collapsedRoute.path === redirect_path) {
                localStorage.setItem("currentScreen", route.name);
                localStorage.setItem("currentSubMenu", collapsedRoute.name);
                getUserModuleAccess(
                  user_id,
                  localStorage.getItem("topbarCompanyId")
                    ? localStorage.getItem("topbarCompanyId")
                    : 99999,
                  route.name
                );
                if (route.name === "CRM") {
                  dispatch(setVisible(true));
                } else {
                  dispatch(setVisible(false));
                }
                dispatch(setCurrentLocation(route.name));
                dispatch(setCurrentScreen(collapsedRoute.name));
                dispatch(setSubMenuExpand(true));
                setRedirect(redirect_path);
              } else if (redirect_path === "/admin/edit/profile/") {
                dispatch(setEditUserId(user_id));
                dispatch(setEditUserDetailsApi(true));
              }
            });
            if (count === 6) {
              const parts = redirect_path.split("/");
              if (parts[2] === "crm") {
                dispatch(setVisible(true));
              }
              setRedirect(redirect_path);
            }
          }
        });
      } else {
        dispatch(setVisible(false));
      }
    },
    [dispatch, getUserModuleAccess, routes]
  );

  const updateCurrentUserDetails = useCallback(
    async (currentUserString, api_token) => {
      const currentUserId = currentUserString
        ? String(currentUserString.id)
        : null;
      dispatch(setCurrentUser(currentUserString));
      const res = await customGetAPIWithToken(
        `${domainUrl}company/`,
        api_token
      );
      if (res.ok) {
        let accessibleProducts = JSON.parse(
          localStorage.getItem("productAccess")
        );

        let product_name = accessibleProducts
          ? accessibleProducts[0]?.product_name
          : "default";
        let redirectPath =
          currentUserString?.type === supportLabel
            ? supportLabel
            : res?.responseDetails?.length === 0 &&
              currentUserString?.type === adminRoleName
            ? "Administration"
            : product_name;
        const accesbasedReroutePath = getAccessBasedRoute(redirectPath);
        setLoading(false);
        let path_config =
          location.pathname === "/" || location.pathname === "/auth/login"
            ? accesbasedReroutePath
            : location.pathname;
        let redirect_path =
          accessibleProducts?.length === 0
            ? "/admin/edit/profile/"
            : path_config;
        if (location.pathname !== "/" && location.pathname !== "/auth/login") {
          const parts = redirect_path.split("/");
          const match = pathAndProducts.find(
            (item) => item.pathname === parts[2]
          );
          const isAccessible = accessibleProducts?.some(
            (product) => product.product_name === match?.productname
          );
          redirect_path =
            isAccessible || redirect_path === "/admin/edit/profile/"
              ? redirect_path
              : "/admin/edit/profile/";
        }
        await getRouteNames(currentUserString.id, redirect_path);
        localStorage.setItem(
          "companyDetails",
          JSON.stringify(res?.responseDetails)
        );
      }
      setAuthenticated(true);
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        showToast("info", "Notification permission isn't granted yet!");
        return;
      }
      const existingUserId = localStorage.getItem("currentUserId");
      const existingToken = localStorage.getItem("fcmToken");
      if (permission === "granted") {
        navigator.serviceWorker.ready.then(async (registration) => {
          try {
            const token = await getToken(messaging, {
              serviceWorkerRegistration: registration,
            });
            if (token !== existingToken || currentUserId !== existingUserId) {
              await updateUserToken(token, currentUserId);
              localStorage.setItem("fcmToken", token);
              localStorage.setItem("currentUserId", currentUserId);
            }
          } catch (error) {
            console.log(error.message);
          }
          window.addEventListener("focus", () => {
            if (navigator.serviceWorker.controller) {
              navigator.serviceWorker.controller.postMessage({ type: "PING" });
            }
          });
          navigator.serviceWorker.addEventListener("message", (event) => {
            if (event.data.deploymentInProgress) {
              localStorage.setItem("deploymentInProgress", true);
              console.log("✅ deploymentInProgress stored!");
            }
          });
          const unsubscribe = onMessage(messaging, (payload) => {
            console.log("payload:", payload);
            if (payload.data) {
              showToast(
                "success",
                payload.data?.body || payload.notification?.body
              );
              if (
                payload.data.body ===
                "The deployment process is ongoing, so please wait for it to be completed"
              ) {
                localStorage.clear();
                localStorage.setItem("LoginTag", "Email");
                history.push("/auth/login");
                window.location.reload();
              }
            }
            if (payload.data && payload.data.triggerApi) {
              callYourApiFunction();
            }
          });

          return () => {
            unsubscribe();
          };
        });
      }
    },
    [
      callYourApiFunction,
      dispatch,
      domainUrl,
      getRouteNames,
      history,
      location.pathname,
      updateUserToken,
    ]
  );

  const getUserDetails = useCallback(async () => {
    if (userEmail || userPhoneNumber) {
      let url = userEmail
        ? `${domainUrl}login/email_verfication/?email=${userEmail}`
        : `${domainUrl}phone_verfication/?phone_no=${userPhoneNumber}`;
      let tenantUrl = userEmail
        ? `${domainUrl}user_tenant/details/?email=${userEmail}`
        : `${domainUrl}user_tenant/details/?phone_number=${userPhoneNumber}`;
      const emailResponse = await fetch(url, {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      });
      const emailReturnResponse = await emailResponse.json();
      if (emailResponse.status === 200) {
        const userData = {
          id: emailReturnResponse.user_id,
          first_name: emailReturnResponse.emailuser.first_name,
          username: emailReturnResponse.emailuser.username,
          last_name: emailReturnResponse.emailuser.last_name,
          email: emailReturnResponse.emailuser.email,
          type: emailReturnResponse.type,
          approver: emailReturnResponse.approver,
          teamlead: emailReturnResponse.teamlead,
          firmName: emailReturnResponse.firm_name,
          approver_id: emailReturnResponse.approver_id,
          image_url: emailReturnResponse.image_url,
          department_id: emailReturnResponse.department_id,
          department_name: emailReturnResponse.department_name,
          employee_id: emailReturnResponse.employee_id,
        };
        currentUserDetails = userData;
        localStorage.setItem("currentuser", JSON.stringify(userData));
        localStorage.setItem("LoginTag", userEmail ? "Email" : "PhoneNo");
        let api_token = tokenDetails
          ? tokenDetails
          : localStorage.getItem("token");
        const userResponse = await fetch(tenantUrl, {
          method: "GET",
          headers: {
            "content-type": "application/json",
          },
        });
        const resData = await userResponse.json();
        if (userResponse?.ok) {
          localStorage.setItem("tenantCount", resData?.length);
        } else {
          showToast("error", resData?.error);
        }
        localStorage.setItem("LoginTag", userEmail ? "Email" : "PhoneNo");
        localStorage.setItem("currentuser", JSON.stringify(userData));
        getCurrentUserAccessibleCompany(
          api_token,
          emailReturnResponse.user_id,
          domainUrl
        );
      }
    }
  }, [
    domainUrl,
    getCurrentUserAccessibleCompany,
    tokenDetails,
    userEmail,
    userPhoneNumber,
  ]);

  useEffect(() => {
    const initApp = async () => {
      if (tokenDetails) {
        localStorage.clear();
        await getUserDetails();
        localStorage.setItem("token", tokenDetails);
      }
      if (!user_token && !tokenDetails) {
        localStorage.setItem("LoginTag", "Email");
        setRedirect("/auth/login");
        setAuthenticated(false);
        setLoading(false);
        dispatch(setVisible(false));
      } else {
        if (user_token) {
          const currentUserString = tokenDetails
            ? currentUserDetails
            : JSON.parse(localStorage.getItem("currentuser"));
          let api_token = tokenDetails
            ? tokenDetails
            : localStorage.getItem("token");
          if (!localStorage.getItem("topbarCompanyId")) {
            await updateCompanyDetails(
              api_token,
              currentUserString.id,
              domainUrl
            );
          }
          updateCurrentUserDetails(currentUserString, api_token);
        }
      }
    };
    initApp();
  }, [
    dispatch,
    domainUrl,
    getUserDetails,
    tokenDetails,
    updateCompanyDetails,
    updateCurrentUserDetails,
    user_token,
  ]);

  return (
    <>
      <BrowserRouter>
        <Switch>
          {authenticated ? (
            <Route
              path="/admin"
              render={(props) =>
                authenticated ? (
                  <AdminLayout {...props} />
                ) : (
                  <Redirect to="/auth/login" />
                )
              }
            />
          ) : (
            <Route
              path="/auth"
              render={(props) =>
                authenticated === false ? (
                  <AuthLayout {...props} />
                ) : (
                  <Redirect to="/admin/myzone/calendar" />
                )
              }
            />
          )}
          <Redirect to={redirect} />
        </Switch>
      </BrowserRouter>
      <KnowlarityWidget2 />
      <ToastContainer toastStyle={toastContainerStyle} />
      {loading ? <Loader info="Loading..." /> : null}
    </>
  );
}
